import { render, staticRenderFns } from "./ufAboutus.vue?vue&type=template&id=5c1eda9f&scoped=true&"
import script from "./ufAboutus.vue?vue&type=script&lang=js&"
export * from "./ufAboutus.vue?vue&type=script&lang=js&"
import style0 from "./ufAboutus.vue?vue&type=style&index=0&id=5c1eda9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1eda9f",
  null
  
)

export default component.exports